/* eslint-disable radix */
/* eslint-disable no-plusplus */
/* eslint-disable new-cap */
/* eslint-disable react/prop-types */
import React, { useState } from "react";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Box from "@mui/material/Box";
import { useLocation } from "react-router-dom";
import styles from "../../Components/ExportButton/ExportButton.styles";
import Button from "../../../../components/common/Button/index";
import Toast from "../../../../components/common/Toast";

function ExportExpired({ data, exportFunction }) {
  const [showToast, setShowToast] = useState(null);
  const location = useLocation();
  const handleExport = async () => {
    const queryParams = new URLSearchParams(location.search);

    const convertDateFormat = (dateString) => {
      if (!dateString) {
        return null;
      }
      const monthMap = {
        Jan: "01",
        Feb: "02",
        Mar: "03",
        Apr: "04",
        May: "05",
        Jun: "06",
        Jul: "07",
        Aug: "08",
        Sep: "09",
        Oct: "10",
        Nov: "11",
        Dec: "12",
      };
      const [day, month, year] = dateString.split("-");
      return `${year}-${monthMap[month]}-${day.padStart(2, "0")}`;
    };
    const endAtFrom = queryParams.get("endAtFrom");
    const endAtTo = queryParams.get("endAtTo");
    // const startAtFrom = queryParams.get("startAtFrom");
    // const startAtTo = queryParams.get("startAtTo");
    try {
      const payload = {
        areaId: queryParams.get("areaId"),
        zoneId: queryParams.get("zoneId") || null,
        regionId: queryParams.get("regionId") || null,
        chapterId: queryParams.get("chapterId") || null,
        districtId: queryParams.get("districtId") || null,
        blockId: queryParams.get("blockId") || null,
        // startAtFrom: convertDateFormat(startAtFrom) || null,
        // startAtTo: convertDateFormat(startAtTo) || null,
        endAtFrom: convertDateFormat(endAtFrom) || null,
        endAtTo: convertDateFormat(endAtTo) || null,
        type: queryParams.get("type") || null,
        fullName: queryParams.get("fullName") || null,
        subscriptionNumber: queryParams.get("subscriptionNumber") || null,
        memberId: queryParams.get("memberId") || null,
      };

      const response = await exportFunction({
        data: payload,
      });
      const { name } = response.data;
      if (response.code === 200) {
        setShowToast({
          message: `${name} will be available shortly under downloads`,
          severity: "success",
        });
      }
    } catch (error) {
      setShowToast({
        message: error,
        severity: "error",
      });
    }
  };

  const disabled = !data || !data.length;

  return (
    <Box style={{ ...styles.dropdown, ...(disabled ? styles.disabled : {}) }}>
      <Box style={styles.dropdownBtn}>
        {" "}
        <Button
          variant="outlined"
          style={styles.leftSideBtn}
          onClick={handleExport}
          label="Download Reports"
          startIcon={
            <SaveAltIcon
              sx={{
                fontSize: "18px",
                fontWeight: "100",
              }}
            />
          }
        />
        <Box sx={styles.arrowIcon}>
          <ArrowDropDownIcon />
        </Box>
      </Box>
      <Toast
        open={!!showToast}
        severity={showToast?.severity || ""}
        message={showToast?.message || ""}
        handleClose={() => {
          setShowToast(null);
        }}
      />
    </Box>
  );
}

export default ExportExpired;
